<template>
  <div class="noData">
    <img src="@/assets/images/no_data.png" alt="">
    <p>暂无数据</p>
  </div>
</template>

<script>
  export default {
    name: "noData"
  }
</script>

<style scoped lang="less">
  .noData{
    text-align: center;
    padding:20px 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/noData.vue